module.exports = __webpack_public_path__ + "static/img/oil.695bb88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taidi/oil.png
// module id = El8v
// module chunks = 19